module.exports = __webpack_public_path__ + "img/400a.f6f8f81a.png";